import type { GroupEdgeSettings } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { type GraphState, isGroupSettings } from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectTopologyPresetDraftGroups: (
  s: GraphState,
) => GroupEdgeSettings[] = createScopedSelector(() =>
  createSelector(prop('layoutSettings', 'presetDraft', 'edges'), (edges) =>
    edges.filter(isGroupSettings),
  ),
);
